module.exports = __webpack_public_path__ + "img/NLogThrower64_ua.fb749e0c.webp";